import { NgModule } from '@angular/core';


import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import { B2CAdminDashboardFiltersComponent } from './b2c-admin-filters.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { Daterangepicker } from 'ng2-daterangepicker';
import { MATERIALS } from '../../../../app.materials';
import { BaseModule } from '../../../../shared/base.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        BsDropdownModule.forRoot(),
        TooltipModule.forRoot(),
        MatSlideToggleModule,
        TypeaheadModule.forRoot(),
        Daterangepicker
    ],
    exports: [
        B2CAdminDashboardFiltersComponent
    ],
    declarations: [B2CAdminDashboardFiltersComponent]
})

export class B2CAdminDashboardFiltersModule { }
